"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class UserProfileStore {
    // setUserProfile = (mitId: string, kerberosId: string, firstName: string, lastName: string, displayName: string) => {
    //     this.userProfile = {
    //         mitId, kerberosId, firstName, lastName, displayName
    //     }
    // }
    constructor(userProfile) {
        this.userProfile = Object.assign({}, userProfile);
    }
    // @action setUserProfile(mitId: string, kerberosId: string, firstName: string, lastName: string, displayName: string): void {
    //     this.userProfile = {
    //         mitId, kerberosId, firstName, lastName, displayName
    //     }
    // }
    setCurrentUser(mitId, kerberosId, firstName, lastName, displayName) {
        this.userProfile = {
            mitId, kerberosId, firstName, lastName, displayName
        };
    }
    get currentUser() {
        return this.userProfile;
    }
}
__decorate([
    mobx_1.observable
], UserProfileStore.prototype, "userProfile", void 0);
__decorate([
    mobx_1.action
], UserProfileStore.prototype, "setCurrentUser", null);
__decorate([
    mobx_1.computed
], UserProfileStore.prototype, "currentUser", null);
const userProfileStore = new UserProfileStore();
exports.default = userProfileStore;
// export default UserProfileStore
